/* ==========================================================================
   راعي الطيب — سكربت الثيم (Shopify)
   السلة (Cart AJAX API) · الخانات عند التمرير · السلايدر · القائمة ·
   منتقي الأوزان · شريط صور المنتجات
   ========================================================================== */
(function () {
  "use strict";

  // بصمة النسخة: إن لم يظهر هذا السطر في Console فالمتصفح يشغّل ملفاً قديماً
  console.info("%c راعي الطيب ", "background:#0F5A3F;color:#EBC66E;border-radius:3px",
               "theme.js v1.0 — زمردي وذهبي");

  const CONF = window.RAA || {};
  const currency = CONF.currency || "د.ع";
  // أسعار Shopify تصل بالسنت (المبلغ × ١٠٠) مهما كانت العملة
  const money = (cents) => Math.round(Number(cents || 0) / 100).toLocaleString("en-US");
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  /* ── الإشعارات ────────────────────────────────────────────────────── */
  const toastHost = $("#toastHost");

  function toast(message, isError = false) {
    if (!toastHost || !message) return;
    const node = document.createElement("div");
    node.className = "toast" + (isError ? " toast--error" : "");
    node.textContent = message;
    toastHost.appendChild(node);
    setTimeout(() => {
      node.style.transition = "opacity .3s, transform .3s";
      node.style.opacity = "0";
      node.style.transform = "translateY(10px)";
      setTimeout(() => node.remove(), 320);
    }, 2800);
  }

  /* ── طيران المنتج إلى السلة: أوضح إشارة نجاح من أي نص ──────────────── */
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function bumpCart() {
    const button = $("[data-cart-open]");
    if (!button) return;
    button.classList.remove("is-bumped");
    void button.offsetWidth;                 // إعادة تشغيل الحركة
    button.classList.add("is-bumped");
  }

  function findVisual(button) {
    const card = button.closest(".product-card, .detail-media, section, article");
    if (!card) return null;
    return card.querySelector(".product-card__media img, .detail-media img")
        || card.querySelector(".product-card__media .bottle-art, .detail-media .bottle-art")
        || card.querySelector("img, svg");
  }

  function flyToCart(button) {
    return new Promise((resolve) => {
      const target = $("[data-cart-open]");
      const source = findVisual(button);
      if (reducedMotion || !target || !source || !source.getBoundingClientRect) return resolve();

      const from = source.getBoundingClientRect();
      const to = target.getBoundingClientRect();
      if (!from.width || !from.height) return resolve();

      const ghost = source.cloneNode(true);
      ghost.classList.add("fly-ghost");
      ghost.removeAttribute("loading");
      Object.assign(ghost.style, {
        width: from.width + "px",
        height: from.height + "px",
        left: from.left + "px",
        top: from.top + "px",
      });
      document.body.appendChild(ghost);

      const dx = to.left + to.width / 2 - (from.left + from.width / 2);
      const dy = to.top + to.height / 2 - (from.top + from.height / 2);

      const animation = ghost.animate(
        [
          { transform: "translate(0,0) scale(1)", opacity: 0.95 },
          { transform: `translate(${dx * 0.55}px, ${dy * 0.4 - 60}px) scale(0.55)`, opacity: 0.85, offset: 0.55 },
          { transform: `translate(${dx}px, ${dy}px) scale(0.12)`, opacity: 0.15 },
        ],
        { duration: 720, easing: "cubic-bezier(.42,0,.25,1)" }
      );

      // finish والمؤقّت كلاهما يستدعيان done — مرة واحدة فقط وإلا نبض العدّاد مرتين
      let finished = false;
      const done = () => {
        if (finished) return;
        finished = true;
        ghost.remove();
        bumpCart();
        resolve();
      };
      animation.addEventListener("finish", done);
      animation.addEventListener("cancel", done);
      setTimeout(done, 900);                 // شبكة أمان إن لم يُطلق الحدث
    });
  }

  /* ── طلبات السلة: واجهة Shopify (‎/cart/*.js) ─────────────────────────── */
  async function cartFetch(path, payload) {
    const response = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload || {}),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      // Shopify يرسل السبب في description (مثل: الكمية المتوفرة أقل)
      throw new Error(data.description || data.message || "تعذّر تنفيذ العملية، حاول مجدداً.");
    }
    return data;
  }

  async function getCart() {
    const response = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    if (!response.ok) throw new Error("HTTP " + response.status);
    return response.json();
  }

  /* ── عرض السلة ────────────────────────────────────────────────────── */
  const drawer = $("#cartDrawer");
  const linesHost = $("#cartLines");
  const emptyState = $("#cartEmpty");
  const footer = $("#cartFooter");
  const lineTemplate = $("#cartLineTemplate");

  function paintTotals(cart) {
    const fee = Number(CONF.deliveryFee || 0);
    $$("[data-cart-count]").forEach((el) => (el.textContent = cart.item_count));
    $$("[data-cart-subtotal]").forEach((el) => (el.textContent = money(cart.total_price)));
    $$("[data-cart-total]").forEach((el) => (el.textContent = money(cart.total_price + fee * 100)));
    $$("[data-cart-delivery]").forEach((el) => {
      el.textContent = fee ? `${fee.toLocaleString("en-US")} ${currency}` : "مجاني";
    });
  }

  function paintDrawer(cart) {
    if (!linesHost || !lineTemplate) return;

    linesHost.innerHTML = "";
    cart.items.forEach((item) => {
      const node = lineTemplate.content.firstElementChild.cloneNode(true);
      node.dataset.id = item.key;

      const thumb = $("[data-thumb]", node);
      thumb.innerHTML = item.image
        ? `<img src="${item.image}" alt="">`
        : `<svg class="bottle-art" viewBox="0 0 200 240" fill="none" aria-hidden="true">
             <rect x="86" y="30" width="28" height="26" rx="4" fill="#C8942B"/>
             <path d="M70 70h60c6 0 10 5 10 11v98c0 8-6 14-14 14H74c-8 0-14-6-14-14V81c0-6 4-11 10-11z"
                   fill="rgba(19,135,90,.14)" stroke="rgba(15,90,63,.45)" stroke-width="2"/>
           </svg>`;

      const nameEl = $("[data-name]", node);
      nameEl.textContent = item.product_title;
      nameEl.href = item.url;

      // الوزن هو ما يشتريه الزبون: variant_title من Shopify
      const weight = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      $("[data-meta]", node).textContent =
        [item.product_type, weight].filter(Boolean).join(" · ") + ` — ${money(item.price)} ${currency}`;
      $("[data-qty]", node).textContent = item.quantity;
      $("[data-line-total]", node).textContent = money(item.final_line_price);

      linesHost.appendChild(node);
    });

    const empty = cart.item_count === 0;
    if (emptyState) emptyState.hidden = !empty;
    if (footer) footer.hidden = empty;
    linesHost.hidden = empty;
  }

  function paint(cart) {
    paintTotals(cart);
    paintDrawer(cart);
    syncCartPage(cart);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = "";
  }

  async function refresh(open = false) {
    try {
      paint(await getCart());
      if (open) openDrawer();
    } catch (error) {
      // لا تبتلع الخطأ: بدونه يبدو الزر كأنه لا يستجيب
      console.error("[راعي الطيب] تعذّر قراءة السلة من /cart.js :", error);
      if (open) toast("تعذّر قراءة السلة. حدّث الصفحة وحاول مجدداً.", true);
    }
  }

  /* ── تحديث صفحة السلة المستقلة ─────────────────────────────────────── */
  function syncCartPage(cart) {
    const rows = $$(".cart-row[data-line]");
    if (!rows.length) return;
    rows.forEach((row) => {
      const item = cart.items.find((i) => i.key === row.dataset.id);
      if (!item) {
        row.remove();
        return;
      }
      $("[data-qty]", row).textContent = item.quantity;
      $("[data-line-total]", row).textContent = money(item.final_line_price);
    });
    if (cart.item_count === 0) window.location.reload();
  }

  /* ── الأحداث ──────────────────────────────────────────────────────── */
  document.addEventListener("click", async (event) => {
    const target = event.target;

    // فتح/إغلاق السلة
    if (target.closest("[data-cart-open]")) {
      event.preventDefault();
      return refresh(true);
    }
    if (target.closest("[data-cart-close]")) return closeDrawer();

    // إضافة منتج
    const addBtn = target.closest("[data-add-to-cart]");
    if (addBtn) {
      event.preventDefault();                 // النموذج يعمل بلا جافاسكربت، وهنا نتولاه نحن
      if (addBtn.disabled) return;

      const sourceId = addBtn.dataset.qtySource;
      const quantity = sourceId ? parseInt($("#" + sourceId).textContent, 10) || 1 : 1;
      // data-busy-keep: زرّ بأيقونة وسطرين (دوائر شريط الصور) — كتابة نصّ فوقه
      // كانت ستمحو الأيقونة وتدمج السطرين عند الإرجاع
      const keep = "busyKeep" in addBtn.dataset;
      const original = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.classList.add("is-busy");
      if (!keep) addBtn.textContent = "جارٍ الإضافة…";

      try {
        await cartFetch("/cart/add.js", { id: Number(addBtn.dataset.addToCart), quantity: quantity });
        // الطيران بعد قبول الخادم: كان يبدأ قبله فيطير المنتج ثم يظهر «غير متوفر»
        await flyToCart(addBtn);             // لا تغطِّ الحركة بالدرج
        paint(await getCart());
        toast("أُضيف إلى السلة");
        openDrawer();
      } catch (error) {
        toast(error.message, true);
      } finally {
        addBtn.disabled = false;
        addBtn.classList.remove("is-busy");
        if (!keep) addBtn.innerHTML = original;
      }
      return;
    }

    // تعديل الكمية في صفحة المنتج — لا تتجاوز مخزون الوزن المختار
    if (target.closest("[data-detail-plus]") || target.closest("[data-detail-minus]")) {
      const box = $("[data-detail-qty]");
      if (!box) return;
      const step = target.closest("[data-detail-plus]") ? 1 : -1;
      const active = $("[data-portion].is-active");
      const stock = active ? parseInt(active.dataset.stock || "0", 10) : 0;
      let next = Math.max(1, (parseInt(box.textContent, 10) || 1) + step);
      if (stock > 0) next = Math.min(next, stock);
      box.textContent = next;
      const qtyInput = $("[data-qty-input]");
      if (qtyInput) qtyInput.value = next;
      return;
    }

    // صور المنتج المصغّرة
    const thumb = target.closest("[data-detail-thumb]");
    if (thumb) {
      const main = $("[data-detail-image]");
      if (main) main.src = thumb.dataset.detailThumb;
      $$("[data-detail-thumb]").forEach((b) => b.classList.toggle("is-active", b === thumb));
      return;
    }

    // أسطر السلة: كمية وحذف
    const line = target.closest("[data-line]");
    if (!line) return;

    const key = line.dataset.id;
    const qtyNode = $("[data-qty]", line);
    const current = parseInt(qtyNode ? qtyNode.textContent : "1", 10) || 1;

    if (target.closest("[data-qty-plus]") || target.closest("[data-qty-minus]")) {
      const next = current + (target.closest("[data-qty-plus]") ? 1 : -1);
      try {
        paint(await cartFetch("/cart/change.js", { id: key, quantity: Math.max(0, next) }));
      } catch (error) {
        toast(error.message, true);
      }
      return;
    }

    if (target.closest("[data-remove]")) {
      try {
        paint(await cartFetch("/cart/change.js", { id: key, quantity: 0 }));
        toast("حُذف من السلة");
      } catch (error) {
        toast(error.message, true);
      }
    }
  });

  // إفراغ السلة
  const clearBtn = $("[data-cart-clear]");
  if (clearBtn) {
    clearBtn.addEventListener("click", async () => {
      if (!window.confirm("هل تريد إفراغ السلة بالكامل؟")) return;
      try {
        paint(await cartFetch("/cart/clear.js", {}));
        toast("أُفرغت السلة");
      } catch (error) {
        toast(error.message, true);
      }
    });
  }

  /* ── قائمة الجوال ─────────────────────────────────────────────────── */
  const menu = $("#mobileMenu");
  document.addEventListener("click", (event) => {
    if (!menu) return;
    if (event.target.closest("[data-menu-open]")) {
      menu.hidden = false;
      document.body.style.overflow = "hidden";
    } else if (event.target.closest("[data-menu-close]") || event.target === menu) {
      menu.hidden = true;
      document.body.style.overflow = "";
    } else if (event.target.closest(".mobile-link")) {
      menu.hidden = true;
      document.body.style.overflow = "";
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeDrawer();
    if (menu && !menu.hidden) {
      menu.hidden = true;
      document.body.style.overflow = "";
    }
  });

  /* ── السلايدر ─────────────────────────────────────────────────────── */
  (function slider() {
    const slides = $$("[data-slide]");
    if (slides.length < 2) return;

    const dots = $$("[data-slide-dot]");
    let index = 0;
    let timer = null;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle("is-active", i === index));
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
    }

    function play() {
      if (reduced) return;
      stop();
      timer = setInterval(() => show(index + 1), 6500);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    $$("[data-slide-next]").forEach((b) => b.addEventListener("click", () => { show(index + 1); play(); }));
    $$("[data-slide-prev]").forEach((b) => b.addEventListener("click", () => { show(index - 1); play(); }));
    dots.forEach((dot) => dot.addEventListener("click", () => { show(Number(dot.dataset.slideDot)); play(); }));

    const hero = $("#hero");
    if (hero) {
      hero.addEventListener("mouseenter", stop);
      hero.addEventListener("mouseleave", play);
    }
    play();
  })();

  /* ── شريط التنقل عند التمرير ──────────────────────────────────────── */
  const nav = $("#navbar");
  if (nav) {
    const onScroll = () => nav.classList.toggle("is-scrolled", window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ── الخانات تظهر عند التمرير ─────────────────────────────────────────
     كل [data-reveal] أسفل الشاشة يُخفى هنا (reveal-pending) ثم يظهر حين يصل
     إليه التمرير. الإخفاء يضيفه السكربت نفسه: إن لم يُحمَّل main.js تبقى
     الخانات ظاهرة، ولا يُخفى ما هو داخل الشاشة أصلاً فلا وميض عند الفتح. */
  (function revealOnScroll() {
    const items = $$("[data-reveal]");
    if (!items.length || reducedMotion || !("IntersectionObserver" in window)) return;

    const fold = window.innerHeight * 0.9;
    const pending = items.filter((el) => el.getBoundingClientRect().top > fold);
    if (!pending.length) return;
    pending.forEach((el) => el.classList.add("reveal-pending"));

    let observer = null;
    function reveal(el) {
      el.classList.remove("reveal-pending");
      el.classList.add("is-revealed");
      if (observer) observer.unobserve(el);
    }
    // قفزة سريعة (رابط #reviews أو سحب قوي) تتخطّى خانات دون أن تمرّ بالشاشة:
    // كل ما صار فوق الشاشة يظهر فوراً حتى لا يبقى مخفياً عند الرجوع
    function releaseSkipped() {
      $$(".reveal-pending").forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight) reveal(el);
      });
    }

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) reveal(entry.target); });
      releaseSkipped();
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.08 });

    pending.forEach((el) => observer.observe(el));
    window.addEventListener("hashchange", releaseSkipped);
    window.addEventListener("load", releaseSkipped);   // فتح الصفحة على /#reviews مباشرة
  })();

  /* ── قوائم التصفية في صفحة المنتجات ───────────────────────────────────
     Shopify يرتّب بمعامل sort_by، والقسم صفحة مستقلة — فالقائمتان تنقلان. */
  $$("[data-nav-select]").forEach((select) => {
    select.addEventListener("change", () => { if (select.value) window.location.href = select.value; });
  });
  $$("[data-sort-select]").forEach((select) => {
    select.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  });

  /* ── تحميل حالة السلة ─────────────────────────────────────────────── */
  refresh(false);
})();


/* ── منتقي الأوزان في صفحة المنتج ───────────────────────────────────────
   الوزن = variant في Shopify. السعر والمخزون يخصّان الوزن لا المنتج، فاختيار
   وزن يُحدّث السعر وهدف زر الإضافة وحقل النموذج معاً. */
(function variantPicker() {
  const box = document.querySelector("[data-portions]");
  if (!box) return;

  const priceEl = document.querySelector("[data-detail-price]");
  const oldEl = document.querySelector("[data-detail-old-price]");
  const discountEl = document.querySelector("[data-detail-discount]");
  const lowEl = document.querySelector("[data-detail-low]");
  const leftEl = document.querySelector("[data-detail-left]");
  const addBtn = document.querySelector("[data-add-to-cart][data-qty-source]");
  const variantInput = document.querySelector("[data-variant-input]");

  box.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-portion]");
    if (!btn || btn.disabled) return;

    box.querySelectorAll("[data-portion]").forEach((b) => b.classList.remove("is-active"));
    btn.classList.add("is-active");

    if (priceEl) priceEl.textContent = btn.dataset.price || "";
    if (oldEl) {
      const old = btn.dataset.oldPrice || "";
      oldEl.textContent = old;
      oldEl.hidden = !old;
    }
    if (discountEl) {
      const off = btn.dataset.discount || "";
      discountEl.textContent = off ? `−${off}%` : "";
      discountEl.hidden = !off;
    }
    const stock = parseInt(btn.dataset.stock || "0", 10);
    if (lowEl) {
      lowEl.hidden = !(stock > 0 && stock <= 5);
      if (leftEl) leftEl.textContent = stock;
    }
    if (variantInput) variantInput.value = btn.dataset.portion;
    // الرابط يحمل الوزن المختار: تحديث الصفحة أو مشاركتها يفتح الوزن نفسه
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", btn.dataset.portion);
      window.history.replaceState({}, "", url.toString());
    }
    if (addBtn) {
      addBtn.dataset.addToCart = btn.dataset.portion;
      addBtn.disabled = stock <= 0;
      addBtn.textContent = stock > 0 ? "أضف إلى السلة" : "نفدت الكمية";
      // الكمية المختارة لا تتجاوز مخزون الوزن الجديد
      const qty = document.querySelector("[data-detail-qty]");
      if (qty && stock > 0 && (parseInt(qty.textContent, 10) || 1) > stock) qty.textContent = stock;
    }
  });
})();

/* ── شريط صور المنتجات (بين شريط الثقة والخانات) ─────────────────────────
   حركة مستمرة بسرعة data-rail-speed (بكسل/ثانية، من store/branding.py) في حلقة
   بلا انقطاع: تُستنسخ العناصر حتى يغطي المسار الشاشة ومجموعة كاملة، وتُطوى
   الإزاحة على عرض المجموعة الأصلية فلا يُرى القفز. الاتجاه: العناصر تمضي يميناً
   وتدخل التالية من اليسار (ترتيب القراءة العربي).
   يتوقف ما دام الماوس فوقه أو التركيز بلوحة المفاتيح فيه أو دائرة مفتوحة، ولا
   يتحرك وحده مع «تقليل الحركة» (الزرّان والسحب يعملان).
   اللمس: ضغطة مطوّلة (أو نقرة) تفتح الدوائر، لمسة خارجها تغلقها، والسحب أفقياً
   يحرّك الشريط. الماوس: الدوائر بـ :hover في CSS. */
(function productRail() {
  const rail = document.querySelector("[data-rail]");
  if (!rail) return;
  const viewport = rail.querySelector("[data-rail-viewport]");
  const track = rail.querySelector("[data-rail-track]");
  const originals = Array.from(track ? track.querySelectorAll("[data-rail-item]") : []);
  if (!viewport || originals.length < 2) return;

  const SPEED = parseFloat(rail.dataset.railSpeed) || 42;
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let clones = [];
  let setWidth = 0;
  let step = 0;
  let x = 0;                 // الإزاحة (بكسل) — تُطوى على setWidth
  let speed = 0;
  let last = 0;
  let tween = null;
  let hovering = false;
  let keyboardFocus = false;
  let onScreen = true;
  let openItem = null;
  let openedAt = 0;
  let swallowUntil = 0;      // بعد ضغطة مطوّلة: نقرة رفع الإصبع لا تُحسب على دائرة
  let builtFor = 0;          // عرض الشريط عند آخر بناء
  let press = null;          // لمسة جارية: {tile, x0, y0, startX, timer, opened, dragging}

  rail.classList.add("is-live");

  const wrap = (value) => ((value % setWidth) + setWidth) % setWidth;
  const render = () => { track.style.transform = `translate3d(${setWidth ? wrap(x) : 0}px, 0, 0)`; };

  function build() {
    clones.forEach((node) => node.remove());
    clones = [];
    if (openItem && !openItem.isConnected) openItem = null;   // كانت نسخة وأُزيلت
    builtFor = viewport.clientWidth;
    const a = originals[0].getBoundingClientRect();
    const b = originals[1].getBoundingClientRect();
    step = Math.abs(a.left - b.left);                    // عرض الصورة + الفجوة
    setWidth = step * originals.length;
    if (!setWidth) return;
    const need = viewport.clientWidth + setWidth * 2;
    for (let width = setWidth; width < need; width += setWidth) {
      originals.forEach((node) => {
        const copy = node.cloneNode(true);
        copy.classList.remove("is-open");
        copy.setAttribute("aria-hidden", "true");
        copy.querySelectorAll("a, button").forEach((el) => { el.tabIndex = -1; });
        track.appendChild(copy);
        clones.push(copy);
      });
    }
    render();
  }

  function openIt(tile) {
    if (openItem && openItem !== tile) openItem.classList.remove("is-open");
    openItem = tile;
    tile.classList.add("is-open");
    openedAt = performance.now();
  }
  function closeIt() {
    if (!openItem) return;
    openItem.classList.remove("is-open");
    openItem = null;
  }

  function nudge(direction) {                            // +1 التالي · −1 السابق
    closeIt();
    tween = { from: x, to: x + direction * step, start: performance.now(), duration: reduced ? 200 : 520 };
    speed = 0;
  }

  function frame(now) {
    const dt = Math.min(0.05, (now - (last || now)) / 1000);
    last = now;
    if (tween) {
      const p = Math.min(1, (now - tween.start) / tween.duration);
      const e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      x = tween.from + (tween.to - tween.from) * e;
      if (p >= 1) tween = null;
      render();
    } else if (onScreen && !(press && press.dragging)) {
      const paused = reduced || hovering || keyboardFocus || openItem;
      speed += ((paused ? 0 : SPEED) - speed) * Math.min(1, dt * 5);
      if (Math.abs(speed) > 0.01) {
        x = wrap(x + speed * dt);
        render();
      }
    }
    requestAnimationFrame(frame);
  }

  // ── الزرّان ─────────────────────────────────────────────────────────────
  rail.querySelector("[data-rail-next]").addEventListener("click", () => nudge(1));
  rail.querySelector("[data-rail-prev]").addEventListener("click", () => nudge(-1));

  // ── التوقف: الماوس فوق الشريط · تركيز لوحة المفاتيح · خارج الشاشة ──────
  rail.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") hovering = true; });
  rail.addEventListener("pointerleave", (e) => { if (e.pointerType === "mouse") hovering = false; });
  rail.addEventListener("focusin", (e) => {
    let visible = false;
    try { visible = e.target.matches(":focus-visible"); } catch (err) { /* Safari أقدم من 15.4 */ }
    // دائرة ضُغطت بالماوس تبقى مركَّزة فتبقى صورتها مفتوحة (:focus-within) — لا تتحرك وهي مفتوحة
    keyboardFocus = visible || Boolean(e.target.closest("[data-rail-item]"));
  });
  rail.addEventListener("focusout", (e) => { if (!rail.contains(e.relatedTarget)) keyboardFocus = false; });
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => { onScreen = entry.isIntersecting; }).observe(rail);
  }

  // ── اللمس: ضغطة مطوّلة أو نقرة تفتح، والسحب الأفقي يحرّك ───────────────
  track.addEventListener("pointerdown", (e) => {
    if (e.pointerType === "mouse" || e.target.closest(".orb")) return;
    const tile = e.target.closest("[data-rail-item]");
    if (!tile) return;
    press = { tile, x0: e.clientX, y0: e.clientY, startX: x, opened: false, dragging: false, id: e.pointerId };
    press.timer = setTimeout(() => {
      if (!press || press.dragging) return;
      openIt(tile);
      press.opened = true;
      if (navigator.vibrate) navigator.vibrate(8);
    }, 380);
  });
  track.addEventListener("pointermove", (e) => {
    if (!press || e.pointerId !== press.id) return;
    const dx = e.clientX - press.x0;
    const dy = e.clientY - press.y0;
    if (!press.dragging && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
      press.dragging = true;
      clearTimeout(press.timer);
      closeIt();
      tween = null;
      try { track.setPointerCapture(e.pointerId); } catch (err) { /* بعض المتصفحات القديمة */ }
    } else if (!press.dragging && Math.abs(dy) > 10) {
      clearTimeout(press.timer);                         // تمرير الصفحة عمودياً
      press = null;
      return;
    }
    if (press.dragging) {
      x = wrap(press.startX + dx);                        // الإصبع يميناً = الشريط يميناً
      render();
    }
  });
  function endPress(e) {
    if (!press || (e && e.pointerId !== press.id)) return;
    clearTimeout(press.timer);
    const { tile, opened, dragging } = press;
    press = null;
    speed = 0;
    if (opened) swallowUntil = performance.now() + 400;
    if (dragging || opened || e.type === "pointercancel") return;
    if (tile.classList.contains("is-open")) closeIt();   // نقرة على صورة مفتوحة تغلقها
    else openIt(tile);                                   // نقرة قصيرة تفتح أيضاً
  }
  track.addEventListener("pointerup", endPress);
  track.addEventListener("pointercancel", endPress);
  // قائمة المتصفح عند اللمس المطوّل (حفظ الصورة…) تُمنع داخل الشريط وحده
  track.addEventListener("contextmenu", (e) => {
    if (e.target.closest("[data-rail-item]") && (press || performance.now() - openedAt < 800)) e.preventDefault();
  });
  // رفع الإصبع بعد الفتح قد يُطلق نقرة على دائرة ظهرت تحته (بعض المتصفحات تطلقها
  // حتى بعد ضغطة مطوّلة) — لا تُحسب، وإلا أُضيف المنتج للسلة بلا قصد
  track.addEventListener("click", (e) => {
    const now = performance.now();
    if (e.target.closest(".orb") && (now - openedAt < 450 || now < swallowUntil)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  document.addEventListener("pointerdown", (e) => {
    if (openItem && !openItem.contains(e.target)) closeIt();
  });

  let resizeTimer = null;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (viewport.clientWidth === builtFor) return;     // شريط العنوان في الجوال يغيّر الارتفاع وحده
      const ratio = setWidth ? wrap(x) / setWidth : 0;
      build();
      x = ratio * setWidth;
      render();
    }, 150);
  });

  build();
  requestAnimationFrame(frame);
})();
